import howToInvestMoneyImg from 'assets/images/howToInvestMoney.png';

import { FLIP_BOOK, GIFT_BOOK, FLIP_BOOKS } from '../const';

import { getFlipBookPurchases } from './utils';

const howToInvestMoney = {
  book: {
    id: 'geldanlegen-aktien',
    format: FLIP_BOOKS,
    title: 'How to invest money',
    subtitle: '',
    videos: 'Erwin W. Heri, Nicolas Plain',
    layoutAndProduction: 'Hanspeter Frey',
    scope: { pages: 39, videos: 30 },
    price: [32, 39],
    introductions: ['The first digital book in a series on the basics of investing deals with shares'],
    image: howToInvestMoneyImg,
    overviewImg: howToInvestMoneyImg,
  },
  bookIds: [47, 48],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [FLIP_BOOK, GIFT_BOOK],
  purchases: getFlipBookPurchases([32, 39], [48, 47]),
};

export default howToInvestMoney;
